

export interface IUser {
  userID: number;
  name: string;
  kana: string;
  sei: string;
  mei: string;
  seiKana: string;
  meiKana: string;
  mail: string;
  birthday: string;
  gender: number;
  genderText: string;
  workstyleID: number;
  workstyleText: string;
  styleMode: number;
  status: string;
  role: number;
  roleText: string;
  progress: string;
  jobID: number;
  jobText: string;
  flextime: boolean;
  flextimeText: string;
  departmentID: number;
  departmentText: string;
  workManageId: number;
}

export interface IUserProfile {
  sei: string;
  mei: string;
  seiKana: string;
  meiKana: string;
  mail: string;
  gender: number;
  birthday: string;
}

export class CUser implements IUser {
  public userID = 0;
  public name = '';
  public kana = '';
  public sei = '';
  public mei = '';
  public seiKana = '';
  public meiKana = '';
  public mail = '';
  public gender = 3;
  public genderText = '';
  public birthday = '';
  public birthdayForm = '';
  public workstyleID = 0;
  public workstyleText = '';
  public styleMode = 0;
  public status = '';
  public role = 0;
  public roleText = '';
  public progress = '';
  public jobID = 0;
  public jobText = '';
  public flextime = false;
  public flextimeText = '';
  public departmentID = 0;
  public departmentText = '';
  public workManageId = 0;
}

export class CUserProfile implements IUserProfile {
  public sei = '';
  public mei = '';
  public seiKana = '';
  public meiKana = '';
  public mail = '';
  public gender = 0;
  public birthday = '';
}

export interface ICheckBoxListUser {
  userID: number;
  sei: string;
  mei: string;
  mail: string;
  departmentParentID: number;
  departmentParent: string;
  departmentChildID: number;
  departmentChild: string;
  checked: boolean;
  disable: boolean;
}

export interface IDepartmentUsedUser extends ICheckBoxListUser {
  departmentID: number;
}
